module.exports = __webpack_public_path__ + "img/compact-disc.ad1ff52b.svg";